import '../../sass/plugins/search_widget.scss';
import '../../sass/plugins/search_widget_form.scss';

$(() => {
  const countryMultiSelect = $('input#country-select');
  countryMultiSelect.on('change', ($event) => {
    const { selectedOptions } = $event.target.dataset;
    const selectedCountries = selectedOptions.split(',');
    const newEvent = new CustomEvent('selectedCountriesChanged', {
      detail: { selectedCountries },
    });
    document.body.dispatchEvent(newEvent);
  });
});
